import moment from "moment/moment";

export const numberFormatter = new Intl.NumberFormat("sv-SE", {
  style: "decimal",
  maximumFractionDigits: 0
});
export const numberFormatter2 = new Intl.NumberFormat("sv-SE", {
  style: "decimal",
  maximumFractionDigits: 2
});

export function formatNumber(value, digits) {
  const formatter = digits === 2 ? numberFormatter2 : numberFormatter;
  return value ? formatter.format(value) : value;
}

export const moneyFormatter = new Intl.NumberFormat("sv-SE", {
  style: "currency",
  currency: "SEK"
});

export function formatMoney (value) {
  return moneyFormatter.format(value || 0);
}

export function formatTimestamp(value) {
  if (value) {
    return moment(value).format("YYYY-MM-DD HH:mm");
  }
  return "";
}

export function formatDateTimeLong (value) {
  if (value) {
    return moment(value).locale('sv').format('dddd D MMMM [kl.] H:mm')
  }
  return "";
}

export function formatBytes(value) {
  if (value === 0) return "0";
  var c = 1024;
  var e = ["", "KB", "MB", "GB", "TB"];
  var f = Math.floor(Math.log(value) / Math.log(c));
  return (parseFloat((value / Math.pow(c, f)).toFixed(0)) + " " + e[f]).trim();
}
